import locale from 'localization';

export const customerColumns = [
  { key: 'avatar', text: '', width: '5%' },
  { key: 'cifNumber', text: 'MIF Number', width: '15%' },
  { key: 'name', text: locale.name, width: '15%' },
  { key: 'mobileNumber', text: 'Mobile Number', width: '15%' },
  { key: 'emailAddress', text: 'Email Address', width: '15%' },
  { key: 'type', text: 'Type', width: '15%' },
  { key: 'status', text: locale.status, width: '15%' },
  { key: 'options', text: '', width: '5%' }
];
